// Event anchors remain in Inspect; Binoculars supports sample and message links.
export type SampleViewAnchor =
  | { tab: 'transcript'; param: 'event'; value: string }
  | { tab: 'messages'; param: 'message'; value: string };

export const getSampleViewUrl = ({
  evalSetId,
  filename,
  sampleId,
  epoch,
  anchor,
  viewer = anchor?.tab === 'transcript' ? 'inspect' : 'binoculars',
}: {
  evalSetId: string;
  filename: string;
  sampleId: string;
  epoch: number;
  anchor?: SampleViewAnchor;
  viewer?: 'binoculars' | 'inspect';
}) => {
  const evalSetPath = `/eval-set/${encodeURIComponent(evalSetId)}`;
  if (viewer === 'binoculars') {
    const params = new URLSearchParams({
      filename,
      sample: sampleId,
      epoch: String(epoch),
    });
    if (anchor) params.set(anchor.param, anchor.value);
    return `${evalSetPath}?${params}`;
  }
  const base = `${evalSetPath}/inspect#/logs/${encodeURIComponent(filename)}/samples/sample/${encodeURIComponent(sampleId)}/${epoch}/`;
  if (!anchor) return base;
  return `${base}${anchor.tab}?${anchor.param}=${encodeURIComponent(anchor.value)}`;
};

export interface SampleViewSelection {
  filename: string;
  sampleId: string;
  epoch: number;
  messageId: string | null;
}

// Keep shared sample links from before the default-viewer change working.
export function getSampleViewSelection(
  search: string,
  hash: string
): SampleViewSelection | null {
  const params = new URLSearchParams(search);
  const filename = params.get('filename');
  const sampleId = params.get('sample');
  const epoch = params.get('epoch');
  if (
    filename !== null &&
    sampleId !== null &&
    epoch !== null &&
    /^\d+$/.test(epoch)
  ) {
    return {
      filename,
      sampleId,
      epoch: Number(epoch),
      messageId: params.get('message'),
    };
  }

  const match = hash.match(
    /^#\/logs\/([^/]+)\/samples\/sample\/([^/]+)\/(\d+)(?:\/(?:messages|transcript))?\/?(?:\?(.*))?$/
  );
  if (!match) return null;
  try {
    return {
      filename: decodeURIComponent(match[1]),
      sampleId: decodeURIComponent(match[2]),
      epoch: Number(match[3]),
      messageId: new URLSearchParams(match[4]).get('message'),
    };
  } catch {
    return null;
  }
}
